import React from "react";
import { MainMenu } from "../components/MainMenu/MainMenu";
import { AppTabs } from "../components/AppTabs/AppTabs";
import { Page } from "../components/Page/Page";
import "./PageLayout.css";

export function MainMenuPage() {
  return (
    <Page back={false}>
      <div className="page-layout">
        <div className="page-content">
          <MainMenu />
        </div>
        <div className="page-tabs">
          <AppTabs />
        </div>
      </div>
    </Page>
  );
}
